var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlayrix = function SvgPlayrix(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 192,
    height: 54,
    fill: "none",
    viewBox: "0 0 192 54"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#playrix_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2D2D2D",
    fillRule: "evenodd",
    d: "M130.362 8.881c2.038 0 3.596 1.561 3.596 3.598 0 1.95-1.646 3.553-3.596 3.553a3.568 3.568 0 0 1-3.554-3.553c0-2.037 1.605-3.598 3.554-3.598Zm-75.066 6.284v-5.041h10.732v26.922h-5.461V15.165h-5.271Zm-6.92 22.303c2.655 0 4.886-.925 6.692-2.73 1.808-1.809 2.73-4.193 2.73-7.117 0-2.96-.922-5.344-2.73-7.152-1.808-1.808-4.037-2.731-6.692-2.731-2.037 0-4.923.462-4.923.462H38.07v26.305h5.462v-8.651c1.23 1.076 2.845 1.614 4.844 1.614Zm-3.692-6.309c-.807-.923-1.23-2.115-1.23-3.538 0-1.423.423-2.613 1.23-3.536a4.087 4.087 0 0 1 3.154-1.386c1.27 0 2.308.463 3.116 1.386.845.923 1.27 2.115 1.27 3.536 0 1.425-.425 2.615-1.27 3.538-.808.923-1.846 1.386-3.116 1.386a4.087 4.087 0 0 1-3.154-1.386ZM89.448 18.2h-5.502s-2.958-.462-5.23-.462c-2.73 0-5.075.963-6.997 2.846-1.924 1.884-2.884 4.23-2.884 7.039 0 2.807.96 5.153 2.884 7.037 1.922 1.883 4.268 2.806 6.999 2.806 2.039 0 3.77-.614 5.228-1.806v1.384h5.502V18.2Zm-5.5 9.307a4.924 4.924 0 0 1-1.347 3.423c-.883.96-2.037 1.421-3.459 1.421a4.345 4.345 0 0 1-3.309-1.46c-.885-.962-1.345-2.116-1.345-3.384a4.617 4.617 0 0 1 1.307-3.309c.883-.922 2-1.383 3.345-1.383 2.923 0 4.808 2.077 4.808 4.692Zm34.738-4.27v13.807h-5.462V18.2h11.556v5.038h-6.094Zm8.948-5.037v18.844h5.502V18.2h-5.502Zm14.029 0 2.844 4.806 2.847-4.806h6.154l-5.923 9.152 6.345 9.692h-6.116l-3.307-5.345-3.269 5.345h-6.153l6.347-9.692-5.923-9.152h6.154ZM95.514 44.507h5.769L111.782 18.2h-5.844l-4.386 11.652-4.23-11.652h-6.078l7.346 18.844-3.076 7.463Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "playrix_svg__a",
    width: 426.376,
    height: 287.376,
    x: -117.188,
    y: -116.688,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 58.594
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3026_7566"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_3026_7566",
    result: "shape"
  })))));
};
export default SvgPlayrix;